import React, {FC} from "react"

import {DefaultTheme, withTheme} from "styled-components"
import Flex from "@irati/ui/src/Flex"

import {Body, Label, H5} from "@irati/ui/src/Typography"

interface Props {
  id?: string,
  title: string,
  brandName: string,
  desc: string,
  theme: DefaultTheme
}

const CardBody: FC<Props> = ({brandName, title, desc, theme}) => {
  return (
    <Flex direction="column">
      <Flex margin={`0px 0px ${theme.spacing.oneAndHalf} 0px`}>
        <Label large>{brandName}</Label>
      </Flex>
      <Flex margin={`0px 0px ${theme.spacing.two} 0px`} height="48px">
        <H5 overflowWrap="break-word">{title}</H5>
      </Flex>
      <Flex>
        <Body small overflowWrap="break-word">
          {desc}
        </Body>
      </Flex>
    </Flex>
  )
}

export default withTheme(CardBody)
